export const buildInputClasses = ({ bulmaSize, bulmaColor, bulmaStyle, bulmaState }) => {
  const classes = ['input'];
  if (bulmaSize) classes.push(bulmaSize);
  if (bulmaColor) classes.push(bulmaColor);
  if (bulmaStyle) classes.push(bulmaStyle);
  if (bulmaState) classes.push(bulmaState);
  return classes.join(' ');
};

export const buildControlClasses = ({ hasLeftIcon, hasRightIcon, inputClass }) => {
  const classes = ['control'];
  if (hasLeftIcon) classes.push('has-icons-left');
  if (hasRightIcon) classes.push('has-icons-right');
  if (inputClass) classes.push(inputClass);
  return classes.join(' ');
};